<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="max-w-md w-full mx-auto text-center px-4">
      <div class="mb-8">
        <!-- 403 Icon -->
        <div class="mx-auto w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center mb-6">
          <svg class="w-12 h-12 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>

        <!-- Error Code -->
        <h1 class="text-6xl font-bold text-text-primary mb-4">403</h1>

        <!-- Error Title -->
        <h2 class="text-2xl font-semibold text-text-primary mb-4">Access Forbidden</h2>

        <!-- Error Description -->
        <p class="text-text-secondary mb-8">
          {{ errorMessage || 'Sorry, you don\'t have permission to access this resource. Your account may need to be activated or you may need different privileges.' }}
        </p>
      </div>

      <!-- Account Status Info -->
      <div v-if="authStore.isLoggedIn && !isUserActive" class="mb-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <div class="flex items-start">
          <svg class="w-5 h-5 text-yellow-400 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
          </svg>
          <div class="text-left">
            <p class="text-sm font-medium text-yellow-800">Account Activation Required</p>
            <p class="text-sm text-yellow-700 mt-1">Your account is pending activation. Please contact support to activate your account and gain access to this feature.</p>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-4">
        <button
            @click="goBack"
            class="w-full bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Go Back
        </button>

        <router-link
            to="/"
            class="block w-full bg-background-light hover:bg-background-lighter text-text-primary font-medium py-3 px-6 rounded-md border border-background-lighter transition-colors"
        >
          Return to Home
        </router-link>

        <!-- Login button for non-authenticated users -->
        <router-link
            v-if="!authStore.isLoggedIn"
            to="/login"
            class="block w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Login to Continue
        </router-link>

        <!-- Profile button for inactive users -->
        <router-link
            v-else-if="!isUserActive"
            to="/panel/profile"
            class="block w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          Go to Profile
        </router-link>
      </div>

      <!-- Additional Help -->
      <div class="mt-8 pt-8 border-t border-background-lighter">
        <p class="text-sm text-text-secondary mb-4">Need help?</p>
        <div class="flex justify-center space-x-6 text-sm">
          <router-link to="/contact" class="text-primary hover:underline">Contact Support</router-link>
          <router-link to="/faq" class="text-primary hover:underline">FAQ</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useAuthStore } from '../../stores/auth'

export default {
  name: 'Forbidden',
  setup() {
    const authStore = useAuthStore()

    const isUserActive = computed(() => {
      return authStore.user && authStore.user.is_active === 1
    })

    return {
      authStore,
      isUserActive
    }
  },
  computed: {
    errorMessage() {
      return this.$route.query.message || null
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    }
  },
  mounted() {
    document.title = '403 - Access Forbidden | Eskrag'
  }
}
</script>
